'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _reactAddonsCssTransitionGroup = require('react-addons-css-transition-group');

var _reactAddonsCssTransitionGroup2 = _interopRequireDefault(_reactAddonsCssTransitionGroup);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _translate = require('../../redux/i18n/translate');

var _translate2 = _interopRequireDefault(_translate);

var _Chat = require('components/Chat');

var _Media = require('components/Media');

var _Navigation = require('components/Navigation');

var _components = require('components');

var _preloadAssets = require('utils/preloadAssets');

var _Util = require('components/Util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Case = (_dec = (0, _reactRedux.connect)(function (state, props) {
  return { currentLanguage: state.language.lang };
}, {}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Case, _Component);

  function Case(props) {
    (0, _classCallCheck3.default)(this, Case);

    /*CurrentView*/
    /* 0 - Portada parallax
       1 - Video
       2 - Chat        
       3 - Interacción        
       4 - Conclusión
    */
    var _this = (0, _possibleConstructorReturn3.default)(this, (Case.__proto__ || (0, _getPrototypeOf2.default)(Case)).call(this, props));

    _this.showMediaElement = function (e) {

      if (e.target.classList.contains('meneo')) {
        e.target.classList.add('stopMeneo');
        $('.chat')[0].getElementsByClassName('meneo').length - 1;
      } else {
        e.target.parentNode.classList.add('stopMeneo');
      }

      var mediaId = parseInt(e.currentTarget.dataset.mediaId);
      $('.point')[mediaId - 1].classList.add('clickedMedia');

      if (_this.state.mediaElementsShown.map(function (element) {
        return element.mediaId;
      }).indexOf(mediaId) === -1) {
        var elementToShow = _this.state.mediaElements.find(function (element) {
          return element.mediaId === mediaId;
        });
        var mediaElementsShown = _this.state.mediaElementsShown.slice();
        mediaElementsShown.push(elementToShow);
        _this.setState({
          mediaElementsShown: mediaElementsShown
        });
      }
    };

    _this.prepareMediaElements = function (elements) {
      //Ahora procedemos a preparar la estructura de elementos media...
      var mediaElements = elements.reduce(function (result, item) {
        // Si es un elemento que se convertirá en un elemento Media...
        if (item.hasOwnProperty("showMedia")) {
          result.push({ // Este será nuestro "map" del array
            elements: item.showMedia.elements,
            srcThumbnail: item.showMedia.srcThumbnail,
            title: item.showMedia.title,
            mediaId: item.showMedia.mediaId
          });
        }
        return result;
      }, []);

      _this.setState({
        mediaElements: mediaElements
      });

      _this.preloadAssets(_this.context.baseUrl, mediaElements);
    };

    _this.prepareInteractionPoints = function (elements) {
      var position = 0;
      var interactionPoints = elements.reduce(function (result, item) {
        // Si es un elemento que se convertirá en un punto en nuestro TimeBar...
        if (item.hasOwnProperty("showMedia")) {
          var leftPos = result.length === 0 ? 1 : Math.floor(position * 100 / elements.length);
          result.push({ // Este será nuestro "map" del array
            leftPos: leftPos,
            hoverText: item.showMedia.hoverText,
            hoverTitle: item.showMedia.hoverTitle,
            messageId: item.messageId,
            mediaId: item.showMedia.mediaId
          });
        }
        position++;
        return result;
      }, []);

      // El último elemento se posiciona al final
      interactionPoints[interactionPoints.length - 1].leftPos = 99;
      _this.setState({
        interactionPoints: interactionPoints
      });
    };

    _this.scrollToElements = function (e) {
      var messageId = e.currentTarget.dataset.messageId;
      var mediaId = e.currentTarget.dataset.mediaId;

      var messageTo = document.querySelectorAll("div.messageContainer[data-message-id='" + messageId + "']")[0];
      var mediaTo = document.querySelectorAll("div.element[data-media-id='" + mediaId + "']")[0] || document.querySelectorAll("div.swiper[data-media-id='" + mediaId + "']")[0];

      if (messageTo !== undefined) {
        $('#scrollContainer').animate({
          scrollTop: messageTo.offsetTop - $('#scrollContainer').height() + $(messageTo).height() + 70
        }, 750);
      }
      if (mediaTo !== undefined) {
        $('#mediaScrollContainer').animate({
          scrollTop: mediaTo.offsetTop - $('#scrollContainer').height() + $(mediaTo).height() + 70
        }, 750);
      }
    };

    _this.nextFact = function (ev) {

      ev.preventDefault();

      if (!_this.state.conversationDone) {
        _this.refs.conversation.showMessagesBlock();
      } else {

        _this.nextView();
      }
    };

    _this.state = {
      currentCase: _this.props.route.caseId,
      canClick: true,
      progress: 0,
      conversationDone: false,
      interactionPoints: [],
      mediaElements: [],
      mediaElementsShown: [],
      currentView: 0
    };

    _this.addProgress = _this.addProgress.bind(_this);
    _this.setConversationDone = _this.setConversationDone.bind(_this);
    _this.showMediaElement = _this.showMediaElement.bind(_this);
    _this.nextFact = _this.nextFact.bind(_this);
    _this.preloadAssets = _this.preloadAssets.bind(_this);
    _this.nextView = _this.nextView.bind(_this);
    _this.fadeOutSound = _this.fadeOutSound.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Case, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.prepareDataStructures();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.state.currentView === 4) {
        this.refs.layerConclusion.classList.remove('elementToFadeOut');
        this.refs.layerConclusion.classList.remove('hidden');

        this.revealText();
        // this.showMenu();
      }

      // if( this.state.currentView === 1 ){
      //   this.quitMenu();
      // }
    }
  }, {
    key: 'addProgress',
    value: function addProgress() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      this.setState({
        progress: this.state.progress + amount
      });
    }
  }, {
    key: 'setConversationDone',
    value: function setConversationDone() {
      this.setState({
        conversationDone: true
      });

      document.getElementsByClassName('goInteractive')[0].classList.add('visible');
    }
  }, {
    key: 'preloadAssets',
    value: function preloadAssets(baseUrl, mediaElements) {
      var arrangedMediaElements = mediaElements.reduce(function (result, item) {
        item.elements.forEach(function (mediaElement) {
          if (mediaElement.type === "image" || mediaElement.type === "video") {
            result.push({ src: baseUrl + '/' + mediaElement.src });
          }
        });
        result.push({ src: baseUrl + '/' + item.srcThumbnail });
        return result;
      }, []);

      // Llamamos a la función loadAssets de util/preloadAssets
      (0, _preloadAssets.loadAssets)(arrangedMediaElements);
    }
  }, {
    key: 'prepareDataStructures',
    value: function prepareDataStructures() {
      var mergedMessages = [].concat.apply([], this.props.strings[this.props.route.caseId].messages);

      this.prepareInteractionPoints(mergedMessages);
      this.prepareMediaElements(mergedMessages);
    }
  }, {
    key: 'calculateRelativeProgress',
    value: function calculateRelativeProgress() {
      var mergedMessages = [].concat.apply([], this.props.strings[this.props.route.caseId].messages);
      var totalMessages = mergedMessages.length;

      var relativeProgress = Math.floor(this.state.progress * 100 / totalMessages);
      return relativeProgress;
    }
  }, {
    key: 'revealText',
    value: function revealText() {
      var elements = document.getElementsByClassName('hiddenText');
      var size = elements.length - 1;

      var i = 0;

      elements[0].classList.add('showText');
      elements[0].classList.remove('hiddenText');

      var interval = setInterval(function () {
        i++;
        elements[0].classList.add('showText');
        elements[0].classList.remove('hiddenText');

        if (i >= size) {
          clearInterval(interval);

          setTimeout(function () {
            var buttons = document.getElementsByClassName('nextView');
            for (var i = buttons.length - 1; i >= 0; i--) {
              buttons[i].classList.add('showButton');
            }
          }, 1000);
        }
      }, 500);
    }
  }, {
    key: 'quitMenu',
    value: function quitMenu() {
      var topMenu = document.getElementsByClassName("containerMenu");
      topMenu[0].classList.add('hidden');
    }
  }, {
    key: 'showMenu',
    value: function showMenu() {
      var topMenu = document.getElementsByClassName("containerMenu");
      topMenu[0].classList.remove('hidden');
    }
  }, {
    key: 'startInteration',
    value: function startInteration() {
      this.refs.layerInteraction.classList.add('elementToFadeOut');
      setTimeout(function () {
        var layer = document.getElementsByClassName('elementToFadeOut');
        layer[0].classList.add('hidden');
      }, 1000);
    }
  }, {
    key: 'nextView',
    value: function nextView(callback, ev) {
      var _this2 = this;

      ev !== undefined ? ev.preventDefault() : false;

      if (this.state.canClick) {
        //console.log('puedo clicar');

        this.setState({
          currentView: this.state.currentView + 1
        }, function () {
          typeof callback === 'function' && callback();
        });

        this.setState({ canClick: false }, function () {
          setTimeout(function () {
            this.setState({
              canClick: true
            });
          }.bind(_this2), 1500);
        });
      }

      // this.setState({  
      //    currentView: this.state.currentView + 1 
      // }, () => {
      //   typeof callback === 'function' && callback();
      // });
    }
  }, {
    key: 'fadeOutSound',
    value: function fadeOutSound(videoElement) {
      var self = this;
      var vol = 1;
      var intervalOut = 25;

      var intervalID = setInterval(function () {
        if (vol > 0) {
          vol -= 0.05;
          self.refs[videoElement]._volume(vol.toFixed(2));
        } else {
          clearInterval(intervalID);
        }
      }, intervalOut);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props$strings$props$ = this.props.strings[this.props.route.caseId],
          title = _props$strings$props$.title,
          logoFooter = _props$strings$props$.logoFooter,
          titleBottom = _props$strings$props$.titleBottom,
          explanationInteraction = _props$strings$props$.explanationInteraction,
          messages = _props$strings$props$.messages,
          wordsParallax = _props$strings$props$.wordsParallax,
          parallaxContent = _props$strings$props$.parallaxContent,
          description = _props$strings$props$.description,
          button = _props$strings$props$.button,
          buttonStart = _props$strings$props$.buttonStart,
          buttonContinue = _props$strings$props$.buttonContinue,
          buttonSkip = _props$strings$props$.buttonSkip,
          buttonGoInteractive = _props$strings$props$.buttonGoInteractive,
          urlVideo = _props$strings$props$.urlVideo,
          urlSubtitles = _props$strings$props$.urlSubtitles,
          conclusion = _props$strings$props$.conclusion,
          icon = _props$strings$props$.icon,
          interaction = _props$strings$props$.interaction;
      var common = this.props.strings.common;

      var relativeProgress = this.calculateRelativeProgress();
      var currentView = this.state.currentView;
      var showActualView = void 0;
      var caseId = this.props.route.caseId;
      var otherCases = [];

      var self = this;
      (0, _keys2.default)(this.props.strings).map(function (key) {
        if (key != caseId && key != 'common') {
          otherCases.push(self.props.strings[key]);
        }
      });

      var trackLabel = this.props.currentLanguage === "es" ? "Spanish" : "English";

      if (currentView === 0) {
        /* Portada */
        showActualView = _react2.default.createElement(
          'div',
          { key: 'coverPage', className: 'coverPage' },
          _react2.default.createElement('div', { className: 'vignette noise box' }),
          _react2.default.createElement(
            'video',
            { className: 'bgVideo', width: '100%', height: '100%', autoPlay: true, loop: true, muted: true },
            _react2.default.createElement('source', { src: this.context.baseUrl + "/media/video/bg" + caseId + ".mp4", type: 'video/mp4' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'table' },
            _react2.default.createElement(
              'div',
              { className: 'cell' },
              _react2.default.createElement(_components.Parallax, { content: parallaxContent, parallaxClass: caseId }),
              _react2.default.createElement(
                'div',
                { onClick: this.nextView.bind(null, this), className: "nextView " + caseId },
                _react2.default.createElement(
                  'span',
                  null,
                  button
                ),
                _react2.default.createElement('i', { className: 'icon-arrowright' })
              ),
              _react2.default.createElement('h2', { dangerouslySetInnerHTML: { __html: description } }),
              _react2.default.createElement(_Util.LogoFooter, { baseUrl: this.context.baseUrl, logo: logoFooter })
            )
          )
        );
      } else if (currentView === 1) {
        /* Video */
        showActualView = _react2.default.createElement(
          'div',
          { key: 'videoCase', className: 'videoFull' },
          _react2.default.createElement('div', { className: 'vignette noise box' }),
          _react2.default.createElement(_Media.Video, { ref: 'videoCase', sources: [this.context.baseUrl + urlVideo],
            subtitles: [{ src: this.context.baseUrl + urlSubtitles, label: trackLabel, lang: this.props.currentLanguage }],
            autoPlay: true,
            activeSubtitle: 0,
            subtitleOn: this.props.currentLanguage === "en" ? true : false,
            isSubtitled: this.props.currentLanguage === "en" ? true : false,
            layout: 'squareLayout',
            icons: {
              sound: _react2.default.createElement('i', { className: 'icon-sound' }),
              mute: _react2.default.createElement('i', { className: 'icon-mute' }),
              subtitles: _react2.default.createElement('i', { className: 'icon-rectangle-subtitle' })
            },
            controls: true,
            ended: this.nextView.bind(null, this),
            width: '100%',
            height: '100%' }),
          _react2.default.createElement(
            'div',
            { className: 'centralButton' },
            _react2.default.createElement(
              'div',
              { onClick: this.nextView.bind(this, this.fadeOutSound.bind(this, 'videoCase')), className: "nextView " + caseId },
              _react2.default.createElement(
                'span',
                null,
                buttonSkip
              ),
              _react2.default.createElement('i', { className: 'icon-arrowright' })
            )
          )
        );
      } else if (currentView === 2) {
        /* chat */
        showActualView = _react2.default.createElement(
          'div',
          { key: 'case', className: 'case' },
          _react2.default.createElement(_Chat.Conversation, { nextFact: this.nextFact, caseId: caseId, buttonGoInteractive: buttonGoInteractive, ref: 'conversation', height: 300, messages: messages, addProgress: this.addProgress, setConversationDone: this.setConversationDone, conversationDone: this.state.conversationDone, showMediaElement: this.showMediaElement, currentLanguage: this.props.currentLanguage }),
          _react2.default.createElement(_Media.MediaWrapper, { mediaElementsShown: this.state.mediaElementsShown }),
          _react2.default.createElement('span', { className: 'vStick' }),
          _react2.default.createElement('span', { className: 'vStick' }),
          _react2.default.createElement(
            'div',
            { className: 'progressWrapper' },
            _react2.default.createElement(_Navigation.TimeBar, { relativeProgress: relativeProgress, points: this.state.interactionPoints, handleClick: this.scrollToElements })
          ),
          _react2.default.createElement(
            'h1',
            null,
            title
          ),
          _react2.default.createElement(
            'div',
            { className: 'scroll' },
            common.scroll,
            _react2.default.createElement('i', { className: 'icon-mouse' })
          )
        );
      } else if (currentView === 3) {
        /* Interacción */

        switch (caseId) {
          case 'case1':
            showActualView = _react2.default.createElement(
              'div',
              { key: "interactionCase " + caseId, className: "interactionCase " + caseId },
              _react2.default.createElement(_components.Find_Photo, { caseId: caseId, buttonContinue: buttonContinue, copyright: this.props.strings[caseId].interaction.photos.copyright, buttonStart: buttonStart, interactionTxt: interaction, showConclusion: this.nextView.bind(null, this) }),
              _react2.default.createElement(
                'span',
                { className: 'titleBottom' },
                title
              )
            );

            break;

          case 'case2':
            showActualView = _react2.default.createElement(
              'div',
              { key: "interactionCase " + caseId, className: "interactionCase " + caseId },
              _react2.default.createElement(
                'div',
                { className: 'table', ref: 'layerInteraction' },
                _react2.default.createElement(
                  'div',
                  { className: 'cell' },
                  _react2.default.createElement(
                    'p',
                    null,
                    explanationInteraction
                  ),
                  _react2.default.createElement(
                    'div',
                    { onClick: this.startInteration.bind(this), className: "nextView " + caseId },
                    _react2.default.createElement(
                      'span',
                      null,
                      buttonStart
                    ),
                    _react2.default.createElement('i', { className: 'icon-arrowright' })
                  )
                )
              ),
              _react2.default.createElement(_components.Mapa, { caseId: caseId, showConclusion: this.nextView.bind(null, this), buttonContinue: buttonContinue, buttonStart: buttonContinue, tweets: interaction.tweetsSrc, explanation: explanationInteraction, wrongText: interaction.wrongText })
            );
            break;
          case 'case3':
            showActualView = _react2.default.createElement(
              'div',
              { key: "interactionCase " + caseId, className: "interactionCase " + caseId },
              _react2.default.createElement(_components.Find_Evidences, { caseId: caseId, buttonContinue: buttonContinue, titleBottom: titleBottom, buttonStart: buttonStart, interactionTxt: interaction, showConclusion: this.nextView.bind(null, this), wrongText: interaction.wrongText }),
              _react2.default.createElement(
                'div',
                { className: 'fadeLayerOp' },
                ' '
              )
            );
            break;
          default:
            showActualView = _react2.default.createElement(
              'div',
              { key: "interactionCase " + caseId, className: "interactionCase " + caseId },
              _react2.default.createElement(
                'div',
                { className: 'table', ref: 'layerInteraction' },
                _react2.default.createElement(
                  'div',
                  { className: 'cell' },
                  _react2.default.createElement(
                    'p',
                    null,
                    'SOY UNA INTERACCI\xD3N'
                  )
                )
              )
            );

        }
      } else if (currentView === 4) {
        /* Conclusión */
        showActualView = _react2.default.createElement(
          'div',
          { key: 'conclusionCase', className: 'conclusionCase' },
          _react2.default.createElement(
            'div',
            { className: 'table', ref: 'layerConclusion' },
            _react2.default.createElement(
              'div',
              { className: 'table-cell' },
              _react2.default.createElement(
                'p',
                { className: 'titleView' },
                ' ',
                conclusion.title
              ),
              _react2.default.createElement(
                'p',
                { className: 'titleCase' },
                title
              ),
              (0, _keys2.default)(conclusion.text).map(function (key) {
                if (key == 2) {
                  return _react2.default.createElement(
                    'p',
                    { className: 'hiddenText', key: key + 11 },
                    ' ',
                    _react2.default.createElement('span', { key: key + 10, className: icon + " icon" })
                  );
                }
                return _react2.default.createElement(
                  'p',
                  { className: 'hiddenText', key: key },
                  ' ',
                  conclusion.text[key],
                  ' '
                );
              }),
              _react2.default.createElement(
                'div',
                { className: "nextView " + caseId },
                _react2.default.createElement(
                  'span',
                  null,
                  conclusion.verification.text
                ),
                _react2.default.createElement('a', { href: conclusion.verification.link, title: conclusion.verification.text, target: '_blank' })
              ),
              _react2.default.createElement(
                _reactRouter.Link,
                { to: "/" + this.context.project + "/" + this.props.currentLanguage + conclusion.nextStep.link, draggable: 'false' },
                _react2.default.createElement(
                  'div',
                  { className: "nextView " + caseId },
                  _react2.default.createElement(
                    'span',
                    null,
                    conclusion.nextStep.text
                  ),
                  _react2.default.createElement('i', { className: 'icon-arrowright' })
                )
              )
            )
          ),
          _react2.default.createElement(_Util.LogoFooter, { baseUrl: this.context.baseUrl, logo: logoFooter }),
          _react2.default.createElement(_Util.ConclusionMenu, { currentCase: caseId, otherCases: otherCases, strings: common.conclusion })
        );
      }

      return _react2.default.createElement(
        _reactAddonsCssTransitionGroup2.default,
        { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 2000, transitionEnter: true, transitionEnterTimeout: 1000, transitionLeave: true, transitionLeaveTimeout: 1000 },
        _react2.default.createElement(
          _reactBodyClassname2.default,
          { className: 'case ' + caseId },
          _react2.default.createElement(
            _reactAddonsCssTransitionGroup2.default,
            { transitionName: 'view', transitionAppear: true, transitionAppearTimeout: 2000, transitionEnter: true, transitionEnterTimeout: 2000, transitionLeave: true, transitionLeaveTimeout: 2000 },
            showActualView
          )
        )
      );
    }
  }]);
  return Case;
}(_react.Component), _class2.displayName = 'Case', _class2.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _class2.propTypes = {
  strings: _react.PropTypes.object.isRequired,
  location: _react.PropTypes.object.isRequired,
  route: _react.PropTypes.object.isRequired
}, _temp)) || _class);
exports.default = (0, _translate2.default)('Case')(Case);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Case/Case.js
// module id = 812
// module chunks = 0